import { PopupType } from '../../../components/popup/types';
import { configActions } from '../../../store/slices/config/slice';
import { popupActions } from '../../../store/slices/popup/slice';
import type { GameCommunicationMessageType } from '../types';
import { MessageName } from '../types';

import { BaseCoreGameCommunicationProcessor } from './BaseCoreGameCommunicationProcessor';

interface RegulationErrorMessage extends GameCommunicationMessageType {
  uId: string;
  code: string;
  gId: string;
  value: string; // FIXME: currently it is a stringifies object with escape characters instead of nested object
}

export class CoreRegulationGameCommunicationProcessor extends BaseCoreGameCommunicationProcessor {
  public messageName = MessageName.RegulationError;

  public process(message: RegulationErrorMessage): void {
    const value = JSON.parse(message.value);

    const interval = (Number(value['rcInterval']) / 60).toString();
    const passed = (Number(value['rcTotalTimeInSession']) / 60).toString();

    this.store.dispatch(configActions.setRealityCheck({ interval, passed }));
    this.store.dispatch(popupActions.pushPopup(PopupType.RealityCheck));
  }
}
